import request from './../request'

// 获取错误列表
export function getErrorPage(params) {
    return request({
        url: '/api/doctor/bike/errors/display/page', // 接口路径
        method: 'get',
        params: params
    })
}
